<section class="simulation grid-container login-page--lg">
    <div>
        <div class="page-header">
            <p class="simulation__panelTitle page-title">
                {{ 'accountactivation.title' | i18n }}
            </p>
            <div class="hide-mobile login-page__caisse">
                <div *ngIf="selectedCaisse" class="login-page__caisseTitle">
                    {{ selectedCaisse.name }}
                </div>
            </div>
        </div>
        <div class="login-page__subtitle">
            {{ 'accountactivation.subtitle' | i18n }}
        </div>
        <div class="login-page__content">
            <form id="accountActivationForm" name="accountActivationForm" [formGroup]="accountActivationForm" (ngSubmit)="submitActivation()" name="accountActivationForm" class="grid-10 grid-mobile-4">
                <div class="grid-12 login-page__input">
                    <label class="grid-6 grid-mobile-4" for="otp"> {{ 'accountactivation.form.otp.label' | i18n }} : </label>
                    <input class="grid-6 grid-mobile-4 textfield" id="otp" name="otp" maxlength="20" required="" formControlName="otp" />
                </div>
                <div class="grid-6 push-6 grid-mobile-4 push-mobile-0">
                    <span class="login-page__inputdesc">
                        {{ 'accountactivation.form.sendsms.text' | i18n }}
                    </span>
                    <span id="re-send-sms-button" data-tag-commander="" [appTagCommander]="'tagCo.accountactivation.sms.button'" class="login-box__link" (click)="demandeActivation(true)"
                        >{{ 'accountactivation.form.sendsms.clickme' | i18n }}
                    </span>
                    <span class="form-message--tiny form-message--success" *ngIf="sendSMSSucces">
                        {{ 'accountactivation.form.sendsms.success' | i18n }}
                    </span>
                    <!-- ngIf: SMSSent===false -->
                </div>

                <app-password-creation [form]="accountActivationForm" [label]="'accountactivation.form.password.label' | i18n" [labelRepeat]="'accountactivation.form.repeatPassword.label' | i18n"> </app-password-creation>

                <div class="grid-12 login-page__input simulation__group login-page__button">
                    <button
                        id="activation-submit"
                        type="submit"
                        class="grid-6 push-6 grid-mobile-4 push-mobile-0 button button--primary"
                        data-tag-commander=""
                        [appTagCommander]="'tagCo.accountactivation.validate.boutton'"
                        data-api-call-button=""
                        [disabled]="!accountActivationForm.valid || newPassword.value != repeatPassword.value"
                        [ngClass]="{ 'icon--loading': submitLoading }"
                    >
                        {{ 'accountactivation.form.submitbutton' | i18n }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</section>
